import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import ResponsiveButton from '@profile/src/Components/ResponsiveButton';
import BreakpointContent from '@profile/src/Components/BreakpointContent';
import icThreeLine from 'assets/svg/ic_three.svg';
import icArrowRight from 'assets/svg/ic_arrow_right_V2.svg';
import Touchable from '@profile/src/Components/Touchable';

const Categories = ({
  selectedKey,
  data,
  className,
  onClickItem
}) => {
  const [showMore, setShowMore] = React.useState(false);
  const [showDropList, setShowDropList] = React.useState(false);
  const moreList = data.slice(4, data.length);
  const selectedMoreItem = moreList.find(e => e.key === selectedKey);

  const renderDesktop = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.container, className)
    }, data.slice(0, 4).map(category => /*#__PURE__*/React.createElement(ResponsiveButton, {
      onClick: () => {
        onClickItem(category);
        setShowMore(false);
      },
      title: category.name,
      className: classNames(styles.item, selectedKey === category.key && styles.active),
      key: category.key
    })), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.item, styles.more, selectedMoreItem && styles.active)
    }, /*#__PURE__*/React.createElement(Touchable, {
      className: styles.btnMore,
      onClick: () => {
        setShowMore(prev => !prev);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, 'More', /*#__PURE__*/React.createElement("img", {
      src: icArrowRight,
      className: styles.icArrowDown
    }))), /*#__PURE__*/React.createElement("div", {
      id: "dropdownMore",
      className: classNames(styles.dropdownMenu, showMore && styles.show)
    }, moreList.map(category => /*#__PURE__*/React.createElement("div", {
      onClick: e => {
        e.stopPropagation();
        onClickItem(category);
        setShowMore(false);
      },
      className: classNames(styles.dropdownItem, selectedKey === category.key && styles.active),
      key: category.key
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, category.name))))));
  };

  const renderPhone = () => {
    const selectedItem = data.find(e => e.key === selectedKey);

    if (!selectedItem) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapper
    }, /*#__PURE__*/React.createElement("div", {
      onClick: () => setShowDropList(prev => !prev),
      className: classNames(styles.containerPhone)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.spanTitle
    }, selectedItem.name), /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: icThreeLine,
      className: styles.icon
    })), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.droplist, showDropList && styles.show)
    }, data.map(category => /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        onClickItem(category);
        setShowDropList(false);
      },
      className: classNames(styles.item, selectedKey === category.key && styles.active),
      key: category.key
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.spanName
    }, category.name)))));
  };

  React.useEffect(() => {
    const onClick = function (e) {
      var _document$getElementB;

      if (!((_document$getElementB = document.getElementById('dropdownMore')) !== null && _document$getElementB !== void 0 && _document$getElementB.contains(e.target))) {
        // Clicked outside the box
        if (showMore) {
          setShowMore(false);
        }
      }
    };

    window.addEventListener('click', onClick);
    return () => {
      window.removeEventListener('click', onClick);
    };
  }, [showMore]);
  return /*#__PURE__*/React.createElement(BreakpointContent, {
    renderDesktop: renderDesktop,
    renderTablet: renderDesktop,
    renderPhone: renderPhone
  });
};

export default Categories;